import Immutable from 'immutable';

import {
  REPORTS_LOADING_ERROR,
  REPORTS_START_LOADING,
  REPORTS_LOADING_SUCCESS
} from '../actions/reports';

const initialState = Immutable.fromJS({
  list: {},
  loadingState: 'IDLE'
});

export default function(state = initialState, action) {
  switch (action.type) {
    case REPORTS_LOADING_SUCCESS: {
      if (action.data) {
        return state
          .setIn(['list'], action.data)
          .setIn(['loadingState'], 'SUCCESS');
      }

      return state;
    }
    case REPORTS_START_LOADING: {
      return state.setIn(['loadingState'], 'PENDING');
    }
    case REPORTS_LOADING_ERROR: {
      return state.set('loadingState', 'REJECT');
    }
    default:
      return state;
  }
}

/* Selectors */

export function getReports(state) {
  return state.getIn(['reports', 'list']);
}

export function getReportsloadingState(state) {
  return state.getIn(['reports', 'loadingState']);
}
